import { render, staticRenderFns } from "./PaginatedList.vue?vue&type=template&id=a138a424&scoped=true&"
import script from "./PaginatedList.vue?vue&type=script&lang=js&"
export * from "./PaginatedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a138a424",
  null
  
)

export default component.exports